import {
  GET_ADMIN_TOPORGANIZERS_REQUEST,
  GET_ADMIN_TOPORGANIZERS_SUCCESS,
  GET_ADMIN_TOPORGANIZERS_ERROR,
  UPDATE_TOPORGANIZERS_STATUS_ERROR,
  UPDATE_TOPORGANIZERS_STATUS_REQUEST,
} from "./constants";

const initialState = {
  loading: false,
  data: [],
};

export default function adminTopOrganizersList(state = initialState, action) {
  switch (action.type) {
    case GET_ADMIN_TOPORGANIZERS_REQUEST:
      return { ...state, loading: true };
    case GET_ADMIN_TOPORGANIZERS_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case GET_ADMIN_TOPORGANIZERS_ERROR:
      return { ...state, loading: false };
    case UPDATE_TOPORGANIZERS_STATUS_REQUEST:
      return { ...state, loading: true };
    case UPDATE_TOPORGANIZERS_STATUS_ERROR:
      return { ...state, data: action.data, loading: false };
    default:
      return state;
  }
}
